import React, { useEffect, useState, useRef } from 'react';
import { Delay } from '../../utils/delay';

const Test2 = (props) => {
  const [color, setColor] = useState(0);
  const [size, setSize] = useState(0);
  const [weight, setWeight] = useState(0);
  const count = useRef(0);
  count.current += 1;

  useEffect(() => {
    console.log('Test2 rendered', count.current);
  });

  const onClickRandomButton = async () => {
    setColor(Math.random() * 10);
    setSize(Math.random() * 10);
    await Delay(2000);
    setWeight(Math.random() * 10);
  };

  return (
    <div>
      <button onClick={onClickRandomButton}>random</button>
      <div>Color: {color.toFixed(2)}</div>
      <div>Size: {size.toFixed(2)}</div>
      <div>Weight: {weight.toFixed(2)}</div>
    </div>
  );
};
export default Test2;
